/* default style for component */
export const style = {
  dialogBox: {
    borderRadius: "22px",
    opacity: 1,
    oveflowX: { xs: "hidden", sm: "hidden" },
    backdropFilter: "blur(10px)",
    "& .MuiPaper-root": {
      maxHeight: "80vh",
      minWidth: { sm: "78vw", md: "50vw" },
    },
  },

  img: {
    height: "40vh",
    width: "15vw",
    display: { xs: "none", sm: "none", md: "block" },
  },

  mainBox: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr", md: "335px 1fr" },
    justifyContent: "space-between",
    gap: "10px",
    padding: "0px 0px 70px 60px",
  },

  forMobile: {
    position: { xs: "relative" },
    right: { sm: "85%", md: "2%" },
    top: { xs: "12%", md: "15%" },
  },

  topText: {
    marginTop: { xs: "-20%", sm: "-6%", md: "1%" },
    marginLeft: { xs: "-4%", sm: "87%", md: "-6%" },
    width: { xs: "93%", md: "max-content" },
    fontSize: "22px",
    fontWeight: 500,
    letterSpacing: "0px",
    color: "#393939",
    opacity: 1,
  },

  reqText: {
    fontSize: "20px",
    fontWeight: 500,
    color: "#020067",
    textAlign: "center",
    mt: -3,
  },

  cancelIcon: {
    fontSize: "35px",
    cursor: "pointer",
    placeSelf: "end",
    top: { xs: "3%" },
    margin: "2% 2%",
  },

  textField: {
    mt: 1,
    width: { md: "25vw" },
    left: { xs: "-7%", sm: "76%", md: "-12%" },
    maxWidth: { xs: "60vw" },
    margin: "auto",
  },

  submitBtn: {
    justifySelf: "end",
    right: { xs: "19%", sm: "-65%", md: "14%" },
    background: "#FD7E00",
    height: "45px",
    width: "30%",
    "&: hover": {
      background: "#FD7E00",
    },
  },

  fieldBox: {
    display: "grid",
    gridTemplateRows: "35px 87px 87px 75px",
    gap: "10px",
  },

  starColor: {
    color: "#393939",
  },

  lastText: {
    fontSize: "15px",
    color: "#393939",
    fontWeight: 400,
    textAlign: "center",
  },

  lastParent: {
    display: "flex",
    width: { sm: "66vw", md: "41vw" },
    position: "relative",
    left: { xs: "-7%", sm: "-5%", md: "7%" },
    top: { xs: "10vw", sm: "6vw", md: "2vw" },
  },
};
